import ScrollAnimations, {
    Instance,
    GroupOptions,
    Target,
    AnimationOptions
} from 'lib/animation/scroll-animations';

export default class Group {
    private items: Instance[] = [];

    constructor(private scrollAnimations: ScrollAnimations, private options: GroupOptions) {
        //
    }

    private push(value: Instance) {
        this.items.push(value);

        return this;
    }

    private animate(target: Target, opts: AnimationOptions, method: 'to' | 'from') {
        const {condition, ...trigOpts} = this.options;

        return this.push(
            this.scrollAnimations.tween(target, {
                condition,
                scrollTrigger: trigOpts,
                ...opts
            }, method)
        )
    }

    to(target: Target, opts: AnimationOptions) {
        return this.animate(target, opts, 'to');
    }

    from(target: Target, opts: AnimationOptions) {
        return this.animate(target, opts, 'from');
    }

    getAnimations() {
        return this.items;
    }
}